// extracted by mini-css-extract-plugin
export default {"button":"Button_button__poVKX","secondary":"Button_secondary__3cHjW","buttonPostion":"Button_buttonPostion__Lcld2"};